<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="100px"
      :disabled="true"
    >
      <el-form-item
        label="承运主体"
        prop="branchCode"
        style="margin-right:15px"
      >
        <el-select v-model="form.branchCode" placeholder="请选择承运主体">
          <el-option
            v-for="item in partyGroupOptions"
            :key="item.code"
            :label="item.groupName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="可编辑类型"
        prop="editType"
        style="margin-right:15px"
      >
        <el-select v-model="form.editType" placeholder="请选择" clearable>
          <el-option
            v-for="item in editTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="配置类型" prop="type" style="margin-right:15px">
        <el-input v-model="form.type" placeholder="请输入配置类型" />
      </el-form-item>
      <el-form-item
        label="配置的key"
        prop="configKey"
        style="margin-right:15px"
      >
        <el-input v-model="form.configKey" placeholder="请输入配置的key" />
      </el-form-item>
      <el-form-item
        label="配置的value"
        prop="configValue"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.configValue"
          type="textarea"
          :rows="5"
          placeholder="请输入配置的value"
        />
      </el-form-item>
      <el-form-item
        label="配置描述"
        prop="configDesc"
        style="margin-right:15px"
      >
        <el-input v-model="form.configDesc" placeholder="请输入配置描述" />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "PartyGroupConfigAdd",
  data() {
    return {
      emptyForm: {},
      form: {
        editType: "",
        type: "",
        configKey: "",
        configValue: "",
        configDesc: "",
        branchCode: ""
      },
      partyGroupOptions: [],
      // 字段类型
      editTypeOptions: [
        { label: "客户", value: "custom" },
        { label: "中台", value: "platform" }
      ],
      rules: {
        branchCode: [
          { required: true, message: "请选择承运主体", trigger: "blur" }
        ],
        editType: [
          { required: true, message: "请选择可编辑类型", trigger: "blur" }
        ],
        type: [{ required: true, message: "请输入配置类型", trigger: "blur" }],
        configKey: [
          { required: true, message: "请输入配置的key", trigger: "blur" }
        ],
        configValue: [
          { required: true, message: "请输入配置的value", trigger: "blur" }
        ],
        configDesc: [
          { required: true, message: "请输入配置描述", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getBranchList();
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    getBranchList() {
      request({
        url: "/ntocc-basic-api/partyGroup",
        method: "get"
      }).then(res => {
        if (res.status === 0) {
          console.log(this.partyGroupOptions);
          this.partyGroupOptions = res.data.records;
        }
      });
    },
    // 获取页面信息
    getInfo(code) {
      //查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      request({
        url: `/ntocc-basic-api/partyGroupConfig/${code}`,
        method: "get"
      }).then(response => {
        this.form = response.data;
      });
    },
    //取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
.el-select {
  width: 100%;
}
.el-date-editor {
  width: 100%;
}
</style>
